import { Box } from '@mui/material';
import React from 'react';

const Footer = () => {
  const today = new Date();
  const yearOnly = today.getFullYear();
  return (
    <Box sx={{ textAlign: 'center', p: 2, mt: 3, backgroundColor: '#65C8D0', color: 'white' }}>
      &copy; {yearOnly} Meveltech Global Solutions Ltd. All rights reserved.
    </Box>
  );
};

export default Footer;
